/**
 * 拷贝对象
 * @param obj
 */
export function copy(obj) {
  const str = JSON.stringify(obj)
  return JSON.parse(str)
}
